import { IItemSchedulingTab } from '../../types/IItemSetup';
import { dataFormatting } from '../../_lib/lib';
import { getShipWindowItemKey } from '../Filters/ShipDateFilter/Utils';

export const getBulkUpdateDataObj = (selectedNodes: any, checkItemState: any) => {
  let selectedQuantity: number = 0,
    availableQuantity: number = 0,
    offerRange = {
      offerLowPrice: Infinity,
      offerHighPrice: -Infinity,
    },
    // an item elected into two overlapping ship windows is one SKU offered by one buyer, not two
    buyerIds = new Set<number>(),
    skuKeys = new Set<string>(),
    reOfferDisabledText = '',
    isAwardDisabled = false,
    offers: any = [];
  const bulkUpdateObject: any = {};
  selectedNodes.forEach((itemData: any) => {
    availableQuantity += itemData.quantityAvailable || 0;
    skuKeys.add(getShipWindowItemKey(itemData));
    if (itemData.itemStatus === IItemSchedulingTab.finalizing)
      reOfferDisabledText = 'must be single SKU';
    if (Array.isArray(itemData.offers) && Array.isArray(itemData.childIdsSelected)) {
      itemData.childIdsSelected.forEach((selectedOfferId: number) => {
        const selectedOffer = itemData.offers.find(
          (offer: any) => selectedOfferId === offer.offerId
        );
        if (!selectedOffer) return;
        bulkUpdateObject[selectedOfferId] = selectedOffer;
        buyerIds.add(selectedOffer.buyerId);
        if (selectedOffer.offerQuantity > selectedOffer.quantityAvailable) isAwardDisabled = true;
        selectedQuantity += selectedOffer.offerQuantity || 0;
        const offerPrice = selectedOffer.offerPrice || 0;
        if (offerPrice <= offerRange.offerLowPrice) {
          offerRange.offerLowPrice = offerPrice;
        }
        if (offerPrice >= offerRange.offerHighPrice) {
          offerRange.offerHighPrice = offerPrice;
        }
        offers.push(selectedOffer);
      });
    }
  });
  if (skuKeys.size > 1) reOfferDisabledText = 'must be single SKU';
  if (availableQuantity === 0) reOfferDisabledText = 'nothing Available';
  const difference = availableQuantity - selectedQuantity;
  if (difference < 0) isAwardDisabled = true;

  const offerRangeStr = `${
    offerRange.offerLowPrice === Infinity
      ? '--'
      : dataFormatting('currency', offerRange.offerLowPrice)
  } to ${
    offerRange.offerHighPrice === -Infinity
      ? '--'
      : dataFormatting('currency', offerRange.offerHighPrice)
  }`;

  const avgPriceStr = `${dataFormatting('currency', checkItemState.avg ?? '--')}`;

  return {
    selectedQuantity,
    availableQuantity,
    difference: difference ?? '--',
    avgPrice: avgPriceStr,
    offerRange: offerRangeStr,
    highestOfferPrice: offerRange.offerHighPrice === -Infinity ? 0 : offerRange.offerHighPrice,
    buyers: buyerIds.size,
    skus: skuKeys.size,
    reOfferDisabledText,
    isAwardDisabled,
    offers,
  };
};
